var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BlankPage',{attrs:{"title":"Fonctionnalités","breadcrumbs":[{name:'Services', path:'#'}, {name:'Fonctionnalités', path:'/functionalities'}]}},[_c('services-home-two',{attrs:{"title":"Comment ça marche !","description":"Jusqu’à ce que votre satisfaction ne fusse TOTALE"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }